// Icons
import PagesIcon from '@material-ui/icons/Pages';
import { BiCategory } from 'react-icons/bi';
import { BsCalendar4Week } from 'react-icons/bs';
import { FaUserFriends } from 'react-icons/fa';
import { MdEventAvailable } from 'react-icons/md';
import { IoInformationCircleOutline } from 'react-icons/io5';
import { BsQuestionOctagon } from 'react-icons/bs';
import { FaRegCircleUser } from 'react-icons/fa6';
import { AiOutlineHome } from 'react-icons/ai';
import { CiViewTimeline, CiRoute, CiSaveUp1 } from 'react-icons/ci';
import FevicyrlContent from './pages/Pages/FevicyrlContent';
import ListETTCSubmissions from './pages/ETTCSubmission/ListETTCSubmissions';
import ListETTCEvaluations from './pages/ETTCSubmission/ListETTCEvaluations';
import {
    HomeFCP,
    NewHomeFCP,
    ContactUs,
    Content,
    Profile,
    ListFCPEventsPlanned,
    ListFCPAssignedHPA,
    HomeCMDI,
    HomeAMMD,
    NewProfile,
} from './pages';

export const FCProutes = {
    items: [
        {
            path: '/newHomeFCP',
            name: 'Home',
            type: 'link',
            icon: AiOutlineHome,
            component: NewHomeFCP,
        },
        {
            path: '/listFCPAssignedHPA',
            name: 'Assigned HPAs',
            icon: FaUserFriends,
            component: ListFCPAssignedHPA,
        },
        {
            path: '/homeFCP',
            name: 'Workshops',
            type: 'link',
            icon: BsCalendar4Week,
            component: HomeFCP,
        },
        {
            path: '/fevicryl-Content',
            name: 'Fevicryl Content Categorization',
            type: 'link',
            icon: BiCategory,
            component: FevicyrlContent,
        },
        {
            path: '/ettc-submissions',
            name: 'ETTC Submissions',
            type: 'link',
            icon: CiSaveUp1,
            component: ListETTCSubmissions,
        },
        {
            path: '/ettc-evaluations',
            name: 'ETTC Evaluations',
            type: 'link',
            icon: CiRoute,
            component: ListETTCEvaluations,
        },
        {
            path: '/profile',
            name: 'My Profile',
            type: 'link',
            icon: FaRegCircleUser,
            component: NewProfile,
        },
        {
            path: '/Info',
            name: 'Info',
            type: 'link',
            icon: IoInformationCircleOutline,
            component: Profile,
        },
        {
            path: '/listFCPEventsPlanned',
            name: 'Events Planned',
            icon: MdEventAvailable,
            component: ListFCPEventsPlanned,
        },
        {
            path: '/content',
            name: 'View training content',
            icon: CiViewTimeline,
            component: Content,
        },
        {
            path: '/contact-us',
            name: 'Contact Us',
            icon: BsQuestionOctagon,
            component: ContactUs,
        },
    ],
};

export const CMDIroutes = {
    items: [
        {
            path: '/homeCMDI',
            name: 'Workshops',
            type: 'link',
            icon: PagesIcon,
            component: HomeCMDI,
        },
    ],
};

export const AMMDroutes = {
    items: [
        {
            path: '/homeAMMD',
            name: 'Workshops',
            type: 'link',
            icon: PagesIcon,
            component: HomeAMMD,
        },
    ],
};
